import { LanguageSwitcher } from '@components/LanguageSwitcher'
import { Stepper } from '@components/Stepper'

import { cancelConsultation } from '@/api/consultations'
import { BackButton } from '@/components/BackButton'
import { GeneralErrorsBanner } from '@/components/GeneralErrorsBanner'
import { Close } from '@/components/icons/Close'
import { useCheckBoxModal } from '@/hooks/useCheckBoxModal'
import { useLoading } from '@/hooks/useLoading'
import { useModule } from '@/hooks/useModule'
import { useReminder } from '@/hooks/useReminder'
import { useStep } from '@/hooks/useStep'
import { useTheme } from '@/hooks/useTheme'
import { useUser } from '@/hooks/useUser'
import { CONSULTATION_STEPS } from '@/types/consultation'

export const Header = () => {
  const { reminderSet } = useReminder()
  const { showLoading, hideLoading, loading } = useLoading()
  const { opened } = useCheckBoxModal()
  const { currentModule } = useModule()
  const { currentStep } = useStep()
  const { theme } = useTheme()
  const { user } = useUser()

  const handleCancelConsultation = () => {
    showLoading()

    cancelConsultation({
      uniqueId: user?.data?.uniqueId as string
    })
      .then(() => {
        window.location.reload()
      })
      .finally(() => {
        hideLoading()
      })
  }

  if (currentStep?.hideHeader) return null

  return (
    <div className={`sticky top-0 z-20 flex w-full flex-col ${reminderSet ? '' : 'shadow-soft'}`}>
      <header className="flex flex-col gap-2 bg-primary bg-header-pattern bg-cover bg-no-repeat py-3 px-6">
        <div className="grid grid-cols-3 gap-x-2">
          {new RegExp(`consultation-(${CONSULTATION_STEPS.MATCH}|${CONSULTATION_STEPS.MATCHING})`).test(currentStep?.id as string) ? (
            <button onClick={handleCancelConsultation} className="disabled:opacity-50" disabled={loading}>
              <Close customClassName="text-white" />
            </button>
          ) : (
            <div className="flex items-center">{currentModule && currentStep?.backButton && <BackButton />}</div>
          )}

          <img src={theme?.logo} alt="Logo" className="mx-auto h-12" />

          {currentStep?.showLanguageSelector && !opened && <LanguageSwitcher disabled={loading} className="animate-fade-in justify-end" />}
        </div>

        {currentModule && currentStep?.stepper && <Stepper />}
      </header>

      <GeneralErrorsBanner />
    </div>
  )
}
